import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSubscription } from '../contexts/SubscriptionContext';
import { useFunnel } from '../contexts/FunnelContext';
import { readOnboardingComplete } from '../utils/guestSession';
import ContentLock from './ContentLock';

/** Temporary: skip onboarding gate (set false to re-enable). */
const ONBOARDING_DISABLED = true;

/**
 * Gate for product routes.
 * strict: onboarding → paywall hard lock
 * soft:   let user through always; paywall shown at player level
 */
const RequireAccess = ({ children }) => {
  const location = useLocation();
  const { booting, onboardingComplete, hasAccess } = useSubscription();
  const { funnelMode } = useFunnel();
  const onboardingDone =
    ONBOARDING_DISABLED || onboardingComplete || readOnboardingComplete();

  // В soft-режиме: онбординг проверяем из storage сразу (без ожидания booting)
  if (funnelMode === 'soft') {
    if (!onboardingDone) {
      return <Navigate to="/onboarding" replace state={{ from: location }} />;
    }
    return children;
  }

  // strict: не блокируем рендер на booting (иначе страница может "висеть").
  if (booting) return children;

  if (!onboardingDone) {
    return <Navigate to="/onboarding" replace state={{ from: location }} />;
  }

  if (hasAccess) return children;

  return <ContentLock />;
};

export default RequireAccess;
